import { Formik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getSpecialities } from "../../redux/slice/form-field/formFieldSlice";
import { getSearchProviders } from "../../redux/slice/provider-search/searchProvidersSlice";
import { setLocalStorageItem } from "../../service/utils";
import Button from "./form-fields/Button";
import DropdownField from "./form-fields/DropdownField";
import { t } from "i18next";

const ProviderNetworkSearchForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { specialitiesData } = useSelector((state) => state.formField);

  useEffect(() => {
    dispatch(getSpecialities());
  }, []);

  return (
    <div>
      <h4>{t("provider-speciality-criteria-label")}</h4>
      <Formik
        initialValues={{
          specialitySearch: "ALL OTHER SPECIALTIES",
        }}
        onSubmit={(values) => {
          const payload = {
            isDownloadPdf: false,
            delta: 10,
            pageNumber: 1,
            sortDirection: 1,
            specialitySearch: values.specialitySearch,
            isSpecialitySearch: true,
          };

          dispatch(getSearchProviders(payload));
          setLocalStorageItem("searchValues", {
            ...payload,
          });

          navigate(`/preferredProviderSearch`);
        }}
      >
        {({ values, handleSubmit, handleChange }) => (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="specialitySearch" className="col-md-4">
                {t("speciality")}
              </label>
              <div className="col-md-8 form-field">
                <DropdownField
                  id="specialitySearch"
                  name="specialitySearch"
                  placeHolder={t("speciality-placeholder")}
                  options={specialitiesData}
                  value={values.specialitySearch}
                  onChange={(event) => {
                    handleChange(event);
                  }}
                />
              </div>
            </div>
            <div className="buttons btn-icon">
              <Button
                isIcon={true}
                icon={"icon-search"}
                buttonText={t("search-button")}
                buttonType={"submit"}
                className={"btn-orange-icon"}
              />

              <Button
                isIcon={true}
                icon={"icon-refresh"}
                buttonText={t("clear-button")}
                buttonType={"reset"}
                className={"btn-orange-icon"}
              />
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default ProviderNetworkSearchForm;
